import { useCallback } from "react";
import _ from "lodash";

import { format, FORMATS, parseISO } from "utils/datetime";

import Stack from "components/Stack";

import TransactionCollapseLine from "pages/Deal/FinancingEvents/TransactionCollapse/TransactionCollapseLine";
import { formatMoneyField } from "pages/Deal/FinancingEvents/TransactionCollapse/utils";

import { ITaxCreditAllocationTransaction } from "entities/Deal/sdk";

interface ITaxCreditAllocationTransactionCollapse {
  taxCreditAllocationTransaction: ITaxCreditAllocationTransaction;
}

const TaxCreditAllocationTransactionCollapse = ({
  taxCreditAllocationTransaction,
}: ITaxCreditAllocationTransactionCollapse) => {
  const formatDate = useCallback(({ date }: { date: string | null }) => {
    if (!_.isNil(date)) {
      const formatedDate = format(parseISO(date), FORMATS.FRONTEND.DATE);
      return !_.isNil(formatedDate) ? formatedDate : "N/A";
    }
    return "N/A";
  }, []);

  return (
    <>
      <Stack display="grid" gridTemplateColumns="1fr 2fr" gap={1}>
        <TransactionCollapseLine
          name="Credit choice"
          value={taxCreditAllocationTransaction.credit_type}
        />
        <TransactionCollapseLine
          name="Regulatory approval date"
          value={formatDate({
            date: taxCreditAllocationTransaction.regulatory_approval_date,
          })}
        />
        <TransactionCollapseLine
          name="First year credit period per 8609"
          value={formatDate({
            date: taxCreditAllocationTransaction.first_year_credit_period_per_8609,
          })}
        />
        <TransactionCollapseLine
          name="Credit amount"
          value={
            !_.isNil(taxCreditAllocationTransaction.credit_amount_10_year)
              ? formatMoneyField({
                  currency:
                    taxCreditAllocationTransaction.credit_amount_10_year
                      .currency,
                  amount:
                    taxCreditAllocationTransaction.credit_amount_10_year.amount,
                })
              : "N/A"
          }
        />
        <TransactionCollapseLine
          name="Housing credit equity"
          value={
            !_.isNil(taxCreditAllocationTransaction.housing_credit_equity)
              ? formatMoneyField({
                  currency:
                    taxCreditAllocationTransaction.housing_credit_equity
                      .currency,
                  amount:
                    taxCreditAllocationTransaction.housing_credit_equity.amount,
                })
              : "N/A"
          }
        />
      </Stack>
      <Stack display="grid" gridTemplateColumns="1fr 1fr" gap={1}>
        <TransactionCollapseLine
          name="Equity provider"
          value={taxCreditAllocationTransaction.equity_provider}
        />
        <TransactionCollapseLine
          name="Equity provider fund name"
          value={taxCreditAllocationTransaction.equity_provider_fund_name}
        />
        <TransactionCollapseLine
          name="Equity amount"
          value={
            !_.isNil(taxCreditAllocationTransaction.equity_amount)
              ? formatMoneyField({
                  currency:
                    taxCreditAllocationTransaction.equity_amount.currency,
                  amount: taxCreditAllocationTransaction.equity_amount.amount,
                })
              : "N/A"
          }
        />
        <TransactionCollapseLine
          name="Price per credit"
          value={
            !_.isNil(taxCreditAllocationTransaction.price_per_credit)
              ? formatMoneyField({
                  currency:
                    taxCreditAllocationTransaction.price_per_credit.currency,
                  amount:
                    taxCreditAllocationTransaction.price_per_credit.amount,
                })
              : "N/A"
          }
        />
        <TransactionCollapseLine
          name="Compliance period"
          value={taxCreditAllocationTransaction.compliance_period}
        />
        <TransactionCollapseLine
          name="Placed in service date"
          value={formatDate({
            date: taxCreditAllocationTransaction.placed_in_service_date,
          })}
        />
      </Stack>
    </>
  );
};

export default TaxCreditAllocationTransactionCollapse;
